import productImages from '~/js/components/product-images';
import variantInfoUpdater from '~/js/components/variant-info-updater';

let productPage;

const initProductImages = () => {
  const productImagesComponent = productPage.querySelector(
    '[data-component="productImages"]'
  );

  if (productImagesComponent) productImages(productImagesComponent);
};

const initVariantInfoUpdater = () => {
  const variantInfoComponent = productPage.querySelector(
    '[data-component="variantInfo"]'
  );

  if (variantInfoComponent) variantInfoUpdater(variantInfoComponent);
};

const initBackButton = () => {
  const backButton = productPage.querySelector('[data-back-button]');
  if (backButton)
    backButton.addEventListener('click', () => {
      window.history.back();
    });
};

const initProductRating = () => {
  const productRating = productPage.querySelector('[data-product-rating]');
  if (productRating && location.hostname === 'fermliving.com') {
    var summaryBadge = new productStickerSummary();
    summaryBadge.showSummary({
      tsId: 'XF575F4570D00FB0E628016AC1413C06E',
      sku: [productRating.dataset.sku],
      element: '[data-product-rating]',
      starColor: '#000',
      starSize: '14px',
      fontSize: '12px',
      showRating: 'true',
      scrollToReviews: 'false',
      enablePlaceholder: 'true',
    });
  }
};

const initStoreInventoryButton = () => {
  const storeInventoryButton = productPage.querySelector(
    '[data-store-inventory-button]'
  );
  const storeInventoryDropdown = productPage.querySelector(
    '[data-store-inventory-dropdown]'
  );

  if (storeInventoryButton) {
    storeInventoryButton.addEventListener('click', () => {
      storeInventoryDropdown.classList.toggle('hidden');
    });
  }
};

const initProductPage = () => {
  productPage = document.querySelector('[data-component="productPage"]');
  if (!productPage) return;

  initProductImages();
  initVariantInfoUpdater();
  initBackButton();
  initProductRating();
  initStoreInventoryButton();
};

document.addEventListener('DOMContentLoaded', initProductPage);
document.addEventListener('shopify:section:load', initProductPage);
